import React from "react";
import { Card, CardContent, List, ListItem, Typography } from "@mui/material";

interface DocumentCardProps {
  title: string;
  details: string[][];
}

const VerificationDocumentCard: React.FC<DocumentCardProps> = ({
  title,
  details,
}) => (
  <Card variant="outlined" sx={{ width: 575, mb: 2 }}>
    <CardContent>
      <Typography variant="h6" mb={2}>
        {title}
      </Typography>
      <List>
        {details.map(([primary, secondary]) => (
          <ListItem
            key={primary}
            sx={{ display: "flex", justifyContent: "space-between" }}
          >
            <Typography fontWeight="bold">{primary}</Typography>
            <Typography>{secondary}</Typography>
          </ListItem>
        ))}
      </List>
    </CardContent>
  </Card>
);

export default VerificationDocumentCard;
